import { Autocomplete, TextField, Typography } from '@mui/material';
import { memo, RefObject, SyntheticEvent } from 'react';

interface CityProps {
  name?: string;
  size?: 'small' | 'medium';
  disabled?: boolean;
  value?: string | null;
  options?: string[];
  onChange?: (event: SyntheticEvent<Element, Event>, newValue: string | null, name?: string) => void;
  inputRef?: RefObject<HTMLInputElement>;
  error?: boolean;
  errormsg?: string;
  required?: boolean;
}

const City = ({ name, size, disabled, value, options = [], onChange, inputRef, error, errormsg, required }: CityProps) => {
  return (
    <>
      <Autocomplete
        openOnFocus
        freeSolo
        size={size}
        disabled={disabled}
        options={options}
        value={value}
        onChange={(event, newValue) => {
          if (onChange) {
            onChange(event, newValue, name);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="City"
            name={name}
            inputRef={inputRef}
            required={required}
            sx={
              required === true
                ? {
                    '.MuiFormLabel-asterisk': {
                      color: '#e55353',
                      fontSize: '20px',
                      fontWeight: 700,
                    },
                  }
                : undefined
            }
            error={error}
            onChange={(event) => {
              if (onChange) {
                onChange(event as SyntheticEvent<Element, Event>, event.target.value, name);
              }
            }}
          />
        )}
      />
      <Typography
        sx={{
          marginTop: '2px',
          marginLeft: '10px',
          marginBottom: '0px',
          fontSize: '11px',
          color: 'danger.main',
          // minHeight: "16px",
        }}
      >
        {errormsg ? errormsg : ''}
      </Typography>
    </>
  );
};

export default memo(City);
